import * as apiSW from 'api/recipe/GetRecipeStartingWithV1';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class Recipe {
	public id: string = '';
	public description: string = '';

	public constructor(input?: apiSW.ResponseRecipe) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapToSelectItem(): ISelectItem {
		return {
			id: this.id,
			name: this.description,
		};
	}

	private mapFromApi(input: apiSW.ResponseRecipe): void {
		this.id = input.id;
		this.description = input.description ?? '';
	}
}
